import { DefaultService } from '@/services/DefaultService';

export default class ProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(produto) {
        return this._http.post(`${this._env}/product`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    find(id) {
        return this._http.get(`${this._env}/product/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/product/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    findAll(page = 0, limit = 50, sort, filtros) {
        return this._http.post(encodeURI(`${this._env}/product.json?page=${page}&limit=${limit}&column=${sort.column}&order=${sort.order}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllByAgroVisita(...params) {
		return this._http.get(encodeURI(`${this._env}/agro-visita/produto.json?param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findQtdGrupoSubLinha() {
		return this._http.get(encodeURI(`${this._env}/sales/product/find-qtd-grupo-sub-linha.json`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}
    findAllNaoVinculadoRegraDesconto(page, limit, sort, idvenpoliticadesconto, ...params) {
        return this._http.get(encodeURI(`${this._env}/sales/product/findAllNaoVinculadoRegraDesconto.json?page=${page}&limit=${limit}&column=${sort.column}&order=${sort.order}&idvenpoliticadesconto=${idvenpoliticadesconto}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}